import React from 'react';

interface IComponentProps {
  className?: string;
}

export const EmptyData: React.FC<IComponentProps> = ({ className }) => {
  return <div className={className}>No data</div>;
};
